import script from "./CircularProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./CircularProgress.vue?vue&type=script&setup=true&lang=js"

import "./CircularProgress.vue?vue&type=style&index=0&id=773c1cac&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773c1cac"]])

export default __exports__